<template>
    <div class="searchMachine__result">
        <article class="mediaCard -shadow">
            <div class="mediaCard__inner">
                <div
                    class="mediaCard__media"
                    :style="{ backgroundColor: result.color ? result.color : '#3c82c3' }"
                >
                    <a
                        :href="result.url"
                        class="mediaCard__link"
                    >
                        <img :src="result.image_thumb" v-if="result.image_thumb">
                        <i class="mediaCard__icon fad fa-link" v-else />
                    </a>
                </div>
                <!-- /.mediaCard__media -->
                <div class="mediaCard__content">
                    <h2 class="mediaCard__heading">
                        <a
                            :href="result.url"
                            class="mediaCard__link"
                            v-text="result.title"
                        />
                    </h2>
                    <p
                        v-if="result.description"
                        class="mediaCard__copy"
                        v-text="result.description"
                    />
                </div>
                <!-- /.mediaCard__content -->
                <favorite-action
                    class="mediaCard__save saveIcon"
                    :is-favorite="result.is_saved"
                    :item-id="result.id"
                    item-type="shortcut"
                />
            </div>
            <!-- /.mediaCard__inner -->
        </article>
    </div>
    <!-- /.searchMachine__result -->
</template>

<script>
import FavoriteAction from '../FavoriteAction.vue';

export default {
    name: 'ShortcutResultVue',
    components: {
        FavoriteAction,
    },
    props: {
        result: {
            type: Object,
            required: true,
        },
    },
};
</script>
